import {Directive, ElementRef, AfterViewInit, EventEmitter, Output, Input, OnDestroy} from '@angular/core';

declare var $: any;

@Directive({
    selector: '[appSelect2Icon]'
})
export class Select2IconDirective implements AfterViewInit, OnDestroy {
    @Input() value: any;
    @Output() onChange = new EventEmitter<string[]>();
    public element: any;
    private select2: any;

    constructor(private el: ElementRef) {
        this.element = $(el.nativeElement);
    }

    ngAfterViewInit() {
        this.el.nativeElement.style.width = '100%';
        this.select2 = this.element.select2({
            templateResult: this.iconFormat,
            escapeMarkup: function (m) {
                return m;
            }
        });
        this.element.val(this.value).trigger('change');
        this.element.on('change', (e: any) => {
            this.onChange.emit($(e.target).val());
        });
    }

// Format icon
    public iconFormat(icon) {
        const originalOption = icon.element;
        if (!icon.id) {
            return icon.text;
        }
        const $icon = '<i class="' + $(icon.element).data('icon') + '"></i>' + icon.text;
        return $icon;
    }

    ngOnDestroy() {
        if (this.select2) {
            this.select2.each((i, item) => {
                $(item).select2('destroy');
            });
        }
    }
}
